var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConHeaderDeleteChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.467,
    viewBox: "0 0 20 20.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash_bin",
    "data-name": "Trash bin",
    transform: "translate(-0.5 -0.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 20,
    height: 20,
    transform: "translate(0.5 0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(1.353 0.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M3,6H19.27",
    transform: "translate(-3 -2.384)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M17.655,5.616V18.27a1.808,1.808,0,0,1-1.808,1.808H6.808A1.808,1.808,0,0,1,5,18.27V5.616m2.712,0V3.808A1.808,1.808,0,0,1,9.519,2h3.616a1.808,1.808,0,0,1,1.808,1.808V5.616",
    transform: "translate(-3.192 -2)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    y2: 6.456,
    transform: "translate(6.456 7.748)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y2: 6.456,
    transform: "translate(10.33 7.748)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConHeaderDeleteChatIcon);
export default __webpack_public_path__ + "static/media/con-header-delete-chat-icon.0c059135c0371bea5d54236ca7cfb87d.svg";
export { ForwardRef as ReactComponent };